import { type IntegrationKeapCampaignCheckboxes } from 'pages/settings/pages/integrations/pages/integrationSettings/IntegrationKeapSettings/types'

export const KEAP_SYNC_CHECKBOX_KEYS: IntegrationKeapCampaignCheckboxes[] = [
  'sync_save',
  'sync_update',
]
